import ProdutoServicoService from "../../services/ProdutoServicoService";
import SelectProdutoServico from "./SelectProdutoServico";

export default class SelectProdutoServicoByTipoUsuario extends SelectProdutoServico {

    componentDidUpdate(nextProps) {
        if (nextProps.idTipoProdutoServico !== this.props.idTipoProdutoServico) {
            this.getOptions();
        }
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    getOptions(callBack) {
        if (this.props.idTipoProdutoServico) {
            ProdutoServicoService.getForComboByTipo(this.props.idTipoProdutoServico, (response) => {
                this.setState({ options: response }, () => {
                    if (callBack) {
                        callBack();
                    }
                });
            });
        } else {
            this.setState({ options: [] }, () => {
                if (callBack) {
                    callBack();
                }
            });
        }
    }

    render() {
        return super.render();
    }
}